import "core-js/modules/es.object.from-entries.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

var _templateObject;

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

import "core-js/modules/es.object.from-entries.js";
import * as React from "react";
import { Link } from "gatsby";
import { useLocation } from "@gatsbyjs/reach-router";
import styled from "../../styled-components";
import { replaceHashInColor } from "../../appTheme";

var isUrl = require("is-url"),
    StyledExternalLink = styled.a(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  &.external-url {\n    position: relative;\n\n    :after {\n      content: '';\n      display: inline-block;\n      position: absolute;\n      background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' version='1.1' x='0' y='0' viewBox='0 0 100 125' enable-background='new 0 0 100 100' xml:space='preserve'%3E%3Cpath fill='", "' d='M-408.2-318.5 98.6 4.8c0-0.1 0-0.2-0.1-0.3 0-0.1-0.1-0.2-0.1-0.3 0-0.1 0-0.1-0.1-0.2 0 0 0-0.1 0-0.1 0-0.1-0.1-0.2-0.2-0.3 0-0.1-0.1-0.2-0.2-0.3 -0.1-0.1-0.1-0.2-0.2-0.3C97.7 2.9 97.6 2.8 97.5 2.7c-0.1-0.1-0.2-0.2-0.3-0.3 -0.1-0.1-0.1-0.1-0.2-0.2 -0.1-0.1-0.2-0.2-0.3-0.2 -0.1-0.1-0.2-0.1-0.2-0.2 -0.1-0.1-0.2-0.1-0.3-0.2 -0.1 0-0.2-0.1-0.3-0.1 0 0-0.1 0-0.1-0.1 -0.1 0-0.2 0-0.2-0.1 -0.1 0-0.2-0.1-0.3-0.1 -0.1 0-0.2-0.1-0.4-0.1 -0.1 0-0.2 0-0.3 0 -0.1 0-0.3 0-0.4 0 -0.1 0-0.1 0-0.2 0L63.8 1.3c-2.5 0-4.6 2.1-4.6 4.6 0 2.5 2.1 4.6 4.6 4.5l19.3-0.1 -29.8 30.2c-1.1 1.1-1.5 2.7-1.2 4.1 0.2 0.9 0.6 1.7 1.3 2.4 0.9 0.9 2.1 1.3 3.2 1.3 1.2 0 2.3-0.5 3.2-1.4l0 0 29.8-30.2 0.1 19.3c0 2.5 2.1 4.6 4.6 4.5 1.3 0 2.4-0.5 3.2-1.4 0.8-0.8 1.3-2 1.3-3.2L98.7 5.7c0-0.1 0-0.1 0-0.2 0-0.1 0-0.2 0-0.4C98.6 5 98.6 4.9 98.6 4.8zM6.5 83.3c0 5.7 4.6 10.4 10.4 10.4l55.6 0.1c5.7 0 10.4-4.6 10.4-10.4l-0.1-40.8h6.1v40.8c0 9-7.3 16.3-16.3 16.3l-56.4-0.1c-8.6 0-15.6-7-15.6-15.6L0.6 27.8c0-9 7.3-16.3 16.3-16.3l41.1-0.1v6.1L17 17.5c-5.7 0-10.4 4.6-10.4 10.4L6.5 83.3z'/%3E%3C/svg%3E\");\n      width: 10px;\n      height: 10px;\n      background-repeat: no-repeat;\n      top: 50%;\n      right: -15px;\n      transform: translateY(-50%);\n    }\n  }\n"])), function (_ref) {
  var a = _ref.theme;
  return replaceHashInColor(a.colors.text.primary);
}),
    propsList = ["color", "size", "variant", "bgColor", "bgImage", "disableArrow", "withIcon", "maxWidth", "inversed", "transparent", "large"];

export var withPropsFilter = function withPropsFilter(a) {
  return function (b) {
    return function (c) {
      var d = Object.fromEntries(Object.entries(c).filter(function (_ref2) {
        var b = _ref2[0];
        return !a.includes(b);
      }));
      return /*#__PURE__*/React.createElement(b, Object.assign({}, d));
    };
  };
};
export var UniversalLink = withPropsFilter(propsList)(function (a) {
  var _useLocation;

  return "string" == typeof a.to && (isUrl(a.to) || a.to.startsWith("mailto:")) || a.external ? /*#__PURE__*/React.createElement(StyledExternalLink, {
    style: a.style,
    href: a.to,
    target: a.target || a.external && "_blank" || "_self",
    className: (a.external ? "external-url" : "") + " " + a.className,
    rel: a.rel,
    children: a.children,
    "data-cy": "universalLink-" + ("string" == typeof a.children ? a.children : "with-nested-jsx")
  }) : null == a.to ? /*#__PURE__*/React.createElement("a", {
    onClick: a.onClick,
    className: a.className,
    style: a.style
  }, a.children) : /*#__PURE__*/React.createElement(Link, Object.assign({}, a, {
    to: a.to,
    state: _objectSpread({
      previousPath: (_useLocation = useLocation()) === null || _useLocation === void 0 ? void 0 : _useLocation.pathname
    }, a.state)
  }));
});